import { render, staticRenderFns } from "./MainLedgerCard5.vue?vue&type=template&id=bceb56de&scoped=true"
import script from "./MainLedgerCard5.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard5.vue?vue&type=script&lang=js"
import style1 from "./otvoreneStavke.css?vue&type=style&index=1&id=bceb56de&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceb56de",
  null
  
)

export default component.exports